import React, { useEffect, useLayoutEffect, useCallback, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from "antd";
import { getTranslationsInProperForm } from "@util/Scripts";
import { setTranslations, setAllLanguages } from "../appRedux/actions/Actions";
import AppLocale from "./Locales";
import { getAllLanguages } from "../services/restAPI/RestApi";

const LanguageProvider = ({ children }) => {
   const dispatch = useDispatch();

   const { locale } = useSelector(({ settings }) => settings);
   const { translations } = useSelector(({ translations }) => translations);

   const [currentLocale, setCurrentLocale] = useState(AppLocale[locale]);

   const handleInitialTranslations = useCallback(async () => {
      const translations = await getTranslationsInProperForm(currentLocale.locale);

      if (translations) {
         dispatch(setTranslations(translations));
      }
   }, []);

   const getAllAvailableLanguages = useCallback(async () => {
      const languages = await getAllLanguages();
      if (languages.data) {
         dispatch(setAllLanguages(languages.data));
      }
   }, []);

   const handleIntlError = (err) => {
      // This clears console from errors about missing translation keys
      // In production they are disabled as default
      if (
         !err?.message?.includes("Missing message") &&
         !err?.message?.includes("Cannot format message")
      ) {
         console.error(err);
      }
   };

   useEffect(() => {
      if (AppLocale[locale]) {
         setCurrentLocale(AppLocale[locale]);
      }
   }, [locale]);

   // We need to set translations before the screen in updated
   useLayoutEffect(() => {
      if (currentLocale?.locale) {
         handleInitialTranslations();
         getAllAvailableLanguages();
      }
   }, []);

   // And after each change in locale
   useEffect(() => {
      if (currentLocale?.locale) {
         getTranslationsInProperForm(currentLocale.locale)
            .then((response) => {
               if (response) {
                  dispatch(setTranslations(response));
               }
            })
            .catch((err) => {
               console.error(err);
            });
      }
   }, [currentLocale]);

   return (
      <ConfigProvider locale={currentLocale.antd}>
         {translations && Object.keys(translations).length > 0 && (
            <IntlProvider
               locale={currentLocale.locale}
               messages={translations}
               onError={handleIntlError}
            >
               {children}
            </IntlProvider>
         )}
      </ConfigProvider>
   );
};

export default LanguageProvider;
